import React, { useState } from 'react';
import { View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import { BestAvailableOrderProps, EventOrderStatProps, TradeProps } from '../store/types/mk_svc';
import { BEEventApi, MarketComponents } from 'be-components';
import { V1_LOAD_EXTERNAL_PRICE_COMPARISON } from '../store/actionsv1/types';
import { market_getLatestTradesByEventId, market_setDraftOrder } from '../store/actionsv1/markets';
import { PlayerPremiumItem } from '../store/types/auth_svc';
import { event_activateEvent, event_loadExternalPrices } from '../store/actionsv1/events';
import moment from 'moment';
import { util_updateShare } from '../store/actionsv1/utils';
import { LoadPriceRequestType, TournamentProps } from '../store/types/sr_svc';

type TournamentHolderProps = {
    tournament_id:string,
    wrap_markets?:boolean,
    market_selector_location?:string,
    hide_liquidity?:boolean,
    navigation:any
}
const TournamentHolder = ({ tournament_id, wrap_markets, market_selector_location, hide_liquidity, navigation }:TournamentHolderProps) => {
    const [ activate_loading, setActivateLoading ] = useState(false);
    const dispatch = useDispatch();
    const leagues = useSelector((state:any) => state.event.leagues, (left, right) => left.length == right.length);
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const tournament = useSelector((state:any) => state.event.tournaments[tournament_id], (left, right) => left == right);
    const league = leagues.find(l => l.league_id == tournament?.league_id);
    const latest_trades:TradeProps[] = useSelector((state:any) => state.market.latest_trades[`tournament:${tournament_id}`], (left, right) => left == right);
    const best_available:BestAvailableOrderProps[] = useSelector((state:any) => state.market.best_available[`tournament:${tournament_id}`], (left, right) => left == right)
    const order_stats:EventOrderStatProps[] = useSelector((state:any) => state.market.order_stats[`tournament:${tournament_id}`], (left, right) => left == right);
    const premium_grades = useSelector((state:any) => state.player.player_premium_items_list.player_premium_items.find((ppi:PlayerPremiumItem) => ppi.premium_item?.identifier == 'order_grades'), (left, right) => left?.last_update_datetime == right?.last_update_datetime);
    const markets = useSelector((state:any) => state.market.markets, (left,right) => left == right);
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);
    let best_avail_fixed = best_available ?? []
    let order_stats_fixed = order_stats ?? []
    let latest_trades_fixed = latest_trades ?? []

    let tourney_avail = best_avail_fixed.filter(ao => ao.event_type == 'tournament');
    let tourney_stats = order_stats_fixed.filter(os => os.event_type == 'tournament');
    let tourney_trades = latest_trades_fixed.filter(lt => lt.event_type == 'tournament');
    let match_available = best_avail_fixed.filter(ao => ao.event_type == 'match');
    let match_stats = order_stats_fixed.filter(os => os.event_type == 'match');
    let match_trades = latest_trades_fixed.filter(ao => ao.event_type == 'match');


    const handleActivateEvent = async() => {
        setActivateLoading(true);
        let price_request:any = {
            event_id: tournament_id,
            event_type: 'tournament',
            activate:true
        }
        await dispatch(event_loadExternalPrices(price_request))


        setTimeout(() => {
            handleRefreshTrades()
        }, 3000);
    }

    const handleRefreshTrades = async() => {
        await dispatch(market_getLatestTradesByEventId(tournament_id, 'tournament'))
        setActivateLoading(false)
    }

    if(!tournament){ return <></> }

    let show_grades = false
    if(player?.type == 'premium' || premium_grades){ show_grades = true }


    return (
        <MarketComponents.TournamentMarket
            tournament={tournament}
            markets={markets}
            league={league}
            onShare={(t:TournamentProps) => {
                let sm = t.supported_markets ? t.supported_markets[0]?.market_id : 10
                dispatch(util_updateShare({
                    share_key: `${t.tournament_id}_share`,
                    visible:true,
                    title: `BettorEdge Markets - ${t.tournament_name}`,
                    type_id: t.tournament_id,
                    link_type: 'user_generated_link',
                    link_sub_type: 'tournament_contest_link',
                    redirect_url: `https://app.bettoredge.com/markets/details/tournament/${t.tournament_id}/52`,
                    embed : {
                        embed_code: `
                            <div id='market' style={{ height: '375px' }} data-tournamentids='${t.tournament_id}' data-eventtype='tournament' />
                            <script src='https://widgets.bettoredge.com/widget.common.js'> </script>\n
                            <script src='https://widgets.bettoredge.com/widget.market.js'> </script>
                            `
                            ,
                        widget_element: <div style={{ height: '375px' }} id='market' data-tournamentids={t.tournament_id} data-eventtype={'tournament'}/>,
                        script_source:'https://widgets.bettoredge.com/widget.market.js',
                        div_id:'market'
                    }
                }))
            }}
            hide_liquidity={hide_liquidity}
            best_available_orders={tourney_avail}
            event_order_stats={tourney_stats}
            latest_trades={tourney_trades}
            match_latest_trades={match_trades}
            match_available_orders={match_available}
            match_order_stats={match_stats}
            market_selector_location={market_selector_location}
            show_grades={show_grades}
            wrap_markets={wrap_markets}
            width={app_size.width-20}
            onEvent={(be_event) => BEEventApi.saveEvent(be_event)}
            activate_loading={activate_loading}
            onActivate={player?.role == 'admin' ? () => handleActivateEvent() :undefined}
            onTradeLongPress={(trade:TradeProps) => {
                dispatch({ 
                    type: V1_LOAD_EXTERNAL_PRICE_COMPARISON, 
                    external_price_comparison: {
                        event_id:trade.event_id,
                        event_type:trade.event_type,
                        init_market:trade.market,
                        side: trade.side,
                        participant_id: trade.market?.level == 'event' ? undefined : trade.side_id,
                        participant_type: trade.market?.level == 'event' ? undefined : trade.side_type
                    }  
                }) 
            }}
            onViewAdditionalMarkets={(tournament_id) => navigation.push('Tournament2', { tournament_id: tournament_id, league_id: tournament.league_id })}
            onView={(d) => navigation.push('Market', { event_id:d.event_id, event_type: d.event_type, market_id: d.market_id, participant_type:d.side_type, participant_id:d.side_id })}
            onOrder={(order) => dispatch(market_setDraftOrder(order))}
        />
    )
}

export default TournamentHolder